import Info from './Info.vue';

export default Info;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/info/index.ts